<label style="width:{{prop.max_length}}px;">
  {{ (detailFormDataModel?.selectedFeature.attributes)[prop.field_name] }}
</label>
